import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M12.533 8A4.533 4.533 0 1 1 8 3.467 4.535 4.535 0 0 1 12.533 8Zm.692 4.5a.734.734 0 1 1-.738-.739.734.734 0 0 1 .738.739Zm.775-.087A1.6 1.6 0 0 1 12.413 14H7.658A6.007 6.007 0 1 1 14 7.428Z';
const draw24px = 'M18.91,12A6.91,6.91,0,1,1,12,5.09,6.91,6.91,0,0,1,18.91,12ZM20,18.86a1.12,1.12,0,1,1-1.13-1.13A1.11,1.11,0,0,1,20,18.86Zm1.18-.13a2.43,2.43,0,0,1-2.42,2.42H11.48a9.16,9.16,0,1,1,9.67-10Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const LogoPlanGridIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'logoPlanGrid'));
LogoPlanGridIcon.displayName = 'LogoPlanGridIcon';
LogoPlanGridIcon.propTypes = Icon.propTypes;
LogoPlanGridIcon.renderIcon = props => /*#__PURE__*/React.createElement(LogoPlanGridIcon, props);
export default LogoPlanGridIcon;
//# sourceMappingURL=LogoPlanGridIcon.js.map